
import ptMessages from '../locales/pt-PT';

const PtLang = {
    messages: {
        ...ptMessages
    },
    locale: 'pt-PT',

};
export default PtLang;